<template>
    <div class="content">
        
        <div class="wrap">
            <img :src="info.picList[0].url" alt="" class="top-img">
            <div class="text">
                <h2>{{info.productName}}</h2>

                <p>
                    {{info.contents}}
                </p>

                <!-- <div>
                    <h6>反光标志牌生产流程：</h6>
                    <p>
                        1、材料采用优质铝合金板，全部采用3M的工程或高强反光膜，夜里具有很好的反光效果。
                    </p>
                    <p>
                        2、根据国家标准尺寸，进行铝板及反光膜剪裁（方形、圆形、三角形）。
                    </p>
                    <p>
                        3、洗净铝板、用白洁布打磨铝板令铝板表面粗糙、用水清洗后晾干。
                    </p>
                    <p>
                        1、材料采用优质铝合金板，全部采用3M的工程或高强反光膜，夜里具有很好的反光效果。
                    </p>
                    <p>
                        2、根据国家标准尺寸，进行铝板及反光膜剪裁（方形、圆形、三角形）。
                    </p>
                    <p>
                        3、洗净铝板、用白洁布打磨铝板令铝板表面粗糙、用水清洗后晾干。
                    </p>
                </div> -->

            </div>
        </div>
        <div class="action">
            <div class="wrap">
                <h2>
                    <a-divider>实景拍摄</a-divider>
                </h2>

                <div class="pic">
                    <img v-for="item in info.picList" :key="item.id" :src="item.url" alt="">
                </div>
            </div>
        </div>

        <div class="m-link">
            <a-divider>分享至</a-divider>
            <div class="d_f f_1 jc_sb ai_c">
                <a href="javascript:void"><img class="h_1" src="../../assets/xl.png" alt=""><p>微信</p></a>
                <a href="javascript:void"><img class="h_1" src="../../assets/wx.png" alt=""><p>QQ</p></a>
                <a href="javascript:void"><img class="h_1" src="../../assets/xl.png" alt=""><p>微博</p></a>
            </div>
        </div>

    </div>
</template>


<script>

import product from '../../api/product'

export default {
    data(){
        return {
            info : {}
        }
    },
    created(){
        let id = this.$route.query.id;
        if(!id){
            // 直接从路由跳转过来的没有带任何参数的 返回新闻列表页
            this.$router.push({path:'/news'});
            return;
        }
        product.selectProductById({id}).then(res=>{
            this.info = res;
        })
    }

}
</script>


<style lang="scss" scoped>
    .content{
        padding: 100px 0 0;
        >.wrap{
             width: 1200px;
             margin:0 auto 30px;
            display: flex;
            justify-content: space-between;
            .top-img{
                width: 360px;
                height: 360px;
            }
            .text{
                width: 780px;
                h2{
                    font-size: 36px;
                    margin-bottom: 20px;
                    padding-bottom: 30px;
                    border-bottom: 1px solid #ccc;
                }
            }
        }
        .action{
            width: 100%;
            background-color: #F8F8F8;
            .wrap{
                display: flex;
                flex-direction: column;
                width: 1200px;
                margin: auto;
                padding: 30px 0;
                h2{
                    width: 300px;
                    display: block;
                    margin: auto;
                }
                .pic{
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    img{
                        height: 79.787vw;
                        margin-bottom: 10px;
                    }
                }
            }
        }
        .m-link{
            display: none;
        }
    }



    @media screen and (max-width: 750px){

        .content{
            padding: 10px 0 0;
            >.wrap{
                display: block;
                width: 100%;
                padding: 0 2.66vw;
                img{
                    display: block;
                    margin: auto;
                    width: 40.16vw !important;
                    height: 34.043vw !important;
                    margin-bottom: 7.979vw;
                }
                .text{
                    width: 100%;
                    h2{
                        border: none;
                        font-size: 4.521vw;
                        margin-bottom: 5.319vw;
                        padding: 0;
                        text-align: center;
                    }
                    p{
                        font-size: 3.458vw !important;
                        line-height: 5.851vw;
                        margin-bottom: 7.979vw;
                    }
                }
            }
            .action{
                .wrap{
                    width: 100%;
                    padding: 0 2.66vw;
                    img{
                        width: 100%;
                        margin-bottom: 7.979vw !important;
                    }
                    h2{
                        width: 39.894vw;
                        padding: 7.979vw 0;
                    }
                }
            }
            .m-link{
                display: block !important;
                height: 28.723vw;
                width: 72.606vw;
                margin: auto;
                a{
                    text-align: center;
                    font-size: 0.2364rem;
                    color: #000;
                }
            }
        }

    }

</style>